/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import {useAuth} from '../core/Auth'
import '../../../../_metronic/assets/sass/components/newPassword.scss'
import {Link, useNavigate, useLocation, useParams} from 'react-router-dom'
import Oklogo from '../../../../_metronic/images/Ok.svg'
import Swal from 'sweetalert2'
import CommonLogin from '../../../../_metronic/helpers/components/login-components/CommonLogin'
import {useLazyQuery, useMutation} from '@apollo/client'
import {RESETPASSWORD, VERIFYRESETPASSWORD} from '../../../../utils/GraphQLAPI'
import withReactContent from 'sweetalert2-react-content'
import {navigateUser} from '../../../../utils/helper'
const MySwal = withReactContent(Swal)

const initialValues = {
  password: '',
  changepassword: '',
}

const newPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Minimum 8 characters are required')
    .max(50, 'Maximum 50 symbols')
    .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d`~!@#$%^&*()_+=\-{}|[\]:;"'<>,.?\/]{8,}$/,
      'Password must contain at least 8 characters, including one letter, one number, and one symbol'
  )
    .required('Password is required'),
  changepassword: Yup.string()
    .required('Password confirmation is required')
    .when('password', {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
    }),
})

export const NewPassword = () => {
  const {saveAuth} = useAuth()
  const [token, setToken] = useState<string | null>()
  const navigate = useNavigate()
  const [passwordType, setPasswordType] = useState<any>('password')
  const [header, setHeader] = useState<string>()
  const search = useLocation().search
  const getUrlParams = useParams()
  const [userRole, setUserRole] = useState<any>()

  // getting the token from url the url
  const getTokenParams = () => {
    const encryptedToken = new URLSearchParams(search).get('key')
    setToken(encryptedToken)
  }

  useEffect(() => {
    const role: any = getUrlParams.adminUser
    getTokenParams()
    navigateUser(role, setHeader, setUserRole)
  }, [getUrlParams])

  useEffect(() => {
    token &&
      verifyResetPassword({
        variables: {
          token,
        },
      })
  }, [token])
  const [verifyResetPassword] = useLazyQuery(VERIFYRESETPASSWORD, {
    onError: (error) => {
      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message,
      }).then(() => {
        navigate(`/${getUrlParams.adminUser}/login`)
      })
    },
  })
  const [resetPassword, {loading}] = useMutation(RESETPASSWORD, {
    onCompleted: (data) => {
      if (data?.resetPassword === 'Success') {
        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
            footer: 'footer-swal',
          },
          width: 660,
          confirmButtonColor: '#009ef7',
          confirmButtonText: 'Sign in',
          title: 'Password changed successfully!',
          text: 'The password has been successfully changed and you may now sign in with your new password to experience the application',
          icon: 'success',
          footer: `<img src="${Oklogo}"></img>`,
        }
        MySwal.fire(options).then((value) => {
          navigate(`/${getUrlParams.adminUser}/login`)
        })
      }
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: e.message,
      })
    },
  })

  const formik = useFormik({
    initialValues,
    validationSchema: newPasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      try {
        await resetPassword({
          variables: {
            token,
            newPassword: values.changepassword,
          },
        })
      } catch (error) {
        saveAuth(undefined)
        setStatus('Passwords are incorrect')
        setSubmitting(false)
      }
    },
  })

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  const showPassword = () => {
    passwordType === 'password' ? setPasswordType('text') : setPasswordType('password')
  }
  return (
    <div
      className='d-flex flex-column h-100 flex-lg-row flex-column-fluid h-100'
      style={{
        backgroundImage: 'linear-gradient(rgb(35, 56, 119), rgb(12, 20, 43))',
        backgroundSize: 'cover',
      }}
    >
      <CommonLogin role={header} userRole={userRole} />
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1 justify-content-center align-items-center'>
        <div className='card card-custom px-8 py-9 ml-3 bg-white h-70 w-500px'>
          <div
            className='card-header'
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <h5 className='card-title'>Setup New Password</h5>
            <p>
              Have you already reset the password ?{' '}
              <Link to={`/${getUrlParams.adminUser}/login`}>Sign In</Link>
            </p>
          </div>
          <form
            className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
            noValidate
            id='kt_login_signup_form'
            onSubmit={formik.handleSubmit}
          >
            {/* begin::Form group Password */}
            <div className='fv-row mb-8' data-kt-password-meter='true'>
              <div className='mb-1'>
                <div className='position-relative mb-3'>
                  <input
                    type={passwordType}
                    placeholder='Password'
                    autoComplete='off'
                    {...formik.getFieldProps('password')}
                    className={clsx(
                      'form-control bg-transparent',
                      {
                        'is-invalid': formik.touched.password && formik.errors.password,
                      },
                      {
                        'is-valid': formik.touched.password && !formik.errors.password,
                      }
                    )}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      right: '50px',
                      top: '50%',
                      transform: 'translate(50%, -50%)',
                    }}
                  >
                    {passwordType === 'password' ? (
                      <i
                        className='bi bi-eye-slash'
                        style={{fontSize: '23px'}}
                        onClick={showPassword}
                      ></i>
                    ) : (
                      <i
                        className='bi bi-eye'
                        style={{fontSize: '23px'}}
                        onClick={showPassword}
                      ></i>
                    )}
                  </div>
                </div>
                {/* begin::Meter */}
                <div
                  className='d-flex align-items-center mb-3'
                  data-kt-password-meter-control='highlight'
                >
                  <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                  <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                  <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                  <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
                </div>
                {/* end::Meter */}
              </div>
              <div className='text-muted'>
                Use 8 or more characters with a mix of letters, numbers & symbols.
              </div>
              {formik.touched.password && formik.errors.password && (
                <div className='fv-plugins-message-container invalid-feedback'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.password}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group Confirm password */}
            <div className='fv-row mb-8'>
              <input
                type='password'
                placeholder='Retype Password'
                autoComplete='off'
                {...formik.getFieldProps('changepassword')}
                className={clsx(
                  'form-control bg-transparent',
                  {
                    'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
                  },
                  {
                    'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
                  }
                )}
              />
              {formik.touched.changepassword && formik.errors.changepassword && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.changepassword}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='text-center'>
              <button
                type='submit'
                id='kt_sign_up_submit'
                className='btn btn-lg btn-primary w-100 mb-5'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {!loading && <span className='indicator-label'>Submit</span>}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            {/* end::Form group */}
          </form>
        </div>
      </div>
    </div>
  )
}
